import { defineComponent as n } from "vue";
import { n as d } from "./_plugin-vue2_normalizer-WQT2Fc8L.js";
import './assets/DButton-C2_EI1lY.css';var _ = /* @__PURE__ */ ((o) => (o.PRIMARY = "primary", o.BLACK = "black", o.GREY = "grey", o.WHITE = "white", o.DANGER = "danger", o))(_ || {}), e = /* @__PURE__ */ ((o) => (o.LARGE = "large", o.SMALL = "small", o))(e || {});
const a = n({
  props: {
    color: { type: String, default: _.PRIMARY },
    size: { type: String, default: e.LARGE },
    disabled: Boolean,
    dark: Boolean,
    short: Boolean,
    peakyCorners: Boolean,
    /** если указан, ренередится как ссылка, иначе - кнопка */
    to: { type: String, default: void 0 },
    /** аналогично `<a target="" />` */
    target: { type: String, default: void 0 }
  },
  emits: ["click"],
  setup() {
    return {
      EColor: _,
      ESize: e
    };
  }
}), s = {
  "d-button": "_d-button_1i2lf_7",
  "d-button_rounded": "_d-button_rounded_1i2lf_25",
  "d-button__prepend": "_d-button__prepend_1i2lf_28",
  "d-button__append": "_d-button__append_1i2lf_33",
  "d-button_size-large": "_d-button_size-large_1i2lf_38",
  "d-button_size-large_short": "_d-button_size-large_short_1i2lf_49",
  "d-button_size-small": "_d-button_size-small_1i2lf_59",
  "d-button_size-small_short": "_d-button_size-small_short_1i2lf_70",
  "d-button_color-primary": "_d-button_color-primary_1i2lf_80",
  "d-button_color-primary_dark": "_d-button_color-primary_dark_1i2lf_90",
  "d-button_color-black": "_d-button_color-black_1i2lf_100",
  "d-button_color-black_dark": "_d-button_color-black_dark_1i2lf_110",
  "d-button_color-grey": "_d-button_color-grey_1i2lf_120",
  "d-button_color-grey_dark": "_d-button_color-grey_dark_1i2lf_130",
  "d-button_color-white": "_d-button_color-white_1i2lf_140",
  "d-button_color-white_dark": "_d-button_color-white_dark_1i2lf_150",
  "d-button_color-danger": "_d-button_color-danger_1i2lf_160",
  "d-button_color-danger_dark": "_d-button_color-danger_dark_1i2lf_170"
};
var i = function() {
  var t = this, r = t._self._c;
  return t._self._setupProxy, r(t.to ? "a" : "button", t._b({ tag: "component", staticClass: "d-button", class: {
    [t.$style["d-button"]]: !0,
    [t.$style["d-button_rounded"]]: !t.peakyCorners,
    [t.$style["d-button_color-primary"]]: t.color === t.EColor.PRIMARY,
    [t.$style["d-button_color-black"]]: t.color === t.EColor.BLACK,
    [t.$style["d-button_color-grey"]]: t.color === t.EColor.GREY,
    [t.$style["d-button_color-white"]]: t.color === t.EColor.WHITE,
    [t.$style["d-button_color-danger"]]: t.color === t.EColor.DANGER,
    [t.$style["d-button_color-primary_dark"]]: t.dark && t.color === t.EColor.PRIMARY,
    [t.$style["d-button_color-black_dark"]]: t.dark && t.color === t.EColor.BLACK,
    [t.$style["d-button_color-grey_dark"]]: t.dark && t.color === t.EColor.GREY,
    [t.$style["d-button_color-white_dark"]]: t.dark && t.color === t.EColor.WHITE,
    [t.$style["d-button_color-danger_dark"]]: t.dark && t.color === t.EColor.DANGER,
    [t.$style["d-button_size-large"]]: t.size === t.ESize.LARGE,
    [t.$style["d-button_size-small"]]: t.size === t.ESize.SMALL,
    [t.$style["d-button_size-large_short"]]: t.short && t.size === t.ESize.LARGE,
    [t.$style["d-button_size-small_short"]]: t.short && t.size === t.ESize.SMALL
  }, attrs: { disabled: t.disabled }, on: { click: function(p) {
    return t.$emit("click");
  } } }, "component", {
    type: t.to ? void 0 : "button",
    href: t.to ? t.to : void 0,
    target: t.to ? t.target : void 0
  }, !1), [t.$slots.prepend ? r("div", { class: t.$style["d-button__prepend"] }, [t._t("prepend")], 2) : t._e(), t._t("default"), t.$slots.append ? r("div", { class: t.$style["d-button__append"] }, [t._t("append")], 2) : t._e()], 2);
}, u = [];
const l = {
  $style: s
};
function c(o) {
  for (var t in l)
    this[t] = l[t];
}
var b = /* @__PURE__ */ d(
  a,
  i,
  u,
  !1,
  c
);
const k = b.exports;
export {
  k as D,
  e as E,
  _ as a
};
